(function () {
  'use strict';
  var motion = window.VroliseMotion;
  var wide = window.matchMedia('(min-width: 1008px)');
  var active = null;
  function attach() {
    var panel = document.getElementById('collection-sort-popover');
    var trigger = document.querySelector('[aria-controls="collection-sort-popover"]');
    if (!panel || !trigger || panel.hasAttribute('data-vr-sort')) return;
    if (active) active.destroy();
    var overlay = document.querySelector('.PageOverlay');
    var x = 0, velocity = 0, target = 0, distance = 1, frame = 0, previous = 0;
    var open = false, shown = false, drag = null, momentum = false, fadeStart = 0, fadeFrom = 0;
    var hidden = new Map(), listeners = [], suppressClick = false, modalLocked = false;
    panel.setAttribute('data-vr-sort', '');
    panel.setAttribute('role', 'dialog');
    panel.setAttribute('aria-label', trigger.getAttribute('aria-label'));
    panel.inert = true;
    function listen(element, name, handler, options) {
      element.addEventListener(name, handler, options);
      listeners.push(function () { element.removeEventListener(name, handler, options); });
    }
    function mobile() { return !wide.matches; }
    function stop() { cancelAnimationFrame(frame); frame = 0; previous = 0; }
    function paint() {
      var progress = Math.max(0, Math.min(1, 1 - x / distance));
      var transform = motion.reduced.matches ? 'none' : mobile() ?
        'translate3d(0,' + x + 'px,0)' : 'scale(' + (.98 + .02 * progress) + ')';
      panel.style.setProperty('--vr-sort-transform', transform);
      panel.style.setProperty('--vr-sort-opacity', mobile() && !motion.reduced.matches ? 1 : progress);
      if (mobile() && shown) overlay.style.opacity = progress;
    }
    function restoreBackground() {
      if (!modalLocked) return;
      modalLocked = false;
      hidden.forEach(function (wasInert, node) { node.inert = wasInert; });
      hidden.clear();
      overlay.classList.remove('is-visible');
      overlay.style.opacity = '';
      overlay.style.transition = '';
      document.documentElement.classList.remove('no-scroll');
      disableBodyScroll(false, '[data-scrollable]');
    }
    function prepareBackground() {
      panel.setAttribute('aria-modal', mobile() ? 'true' : 'false');
      if (!mobile()) return;
      modalLocked = true;
      overlay.style.transition = 'none';
      overlay.classList.add('is-visible');
      document.documentElement.classList.add('no-scroll');
      disableBodyScroll(true, '[data-scrollable]');
      for (var branch = panel; branch.parentElement && branch !== document.body; branch = branch.parentElement) {
        Array.from(branch.parentElement.children).forEach(function (sibling) {
          if (sibling === branch || sibling === overlay || sibling.contains(overlay) || sibling.tagName === 'SCRIPT' || sibling.tagName === 'STYLE') return;
          hidden.set(sibling, sibling.inert);
          sibling.inert = true;
        });
      }
    }
    function layout() {
      panel.style.top = '';
      panel.style.right = '';
      distance = mobile() ? panel.offsetHeight : 1;
      if (mobile()) {
        panel.style.setProperty('--vr-sort-origin', 'center bottom');
        return;
      }
      var rect = trigger.getBoundingClientRect(), height = panel.offsetHeight, width = panel.offsetWidth;
      var below = innerHeight - rect.bottom, above = rect.top;
      var top = below >= height + 20 || below >= above ? rect.bottom + 20 : rect.top - height - 20;
      top = Math.max(8, Math.min(innerHeight - height - 8, top));
      var right = Math.max(8, Math.min(innerWidth - width - 8, innerWidth - rect.right));
      panel.style.top = top + 'px';
      panel.style.right = right + 'px';
      panel.style.setProperty('--vr-sort-origin', Math.max(0, Math.min(width, rect.left + rect.width / 2 - (innerWidth - right - width))) +
        'px ' + Math.max(0, Math.min(height, rect.top + rect.height / 2 - top)) + 'px');
    }
    function finish() {
      stop(); x = target; velocity = 0; paint(); panel.style.willChange = '';
      if (!open) {
        shown = false;
        panel.inert = true;
        panel.setAttribute('aria-hidden', 'true');
        trigger.setAttribute('aria-expanded', 'false');
        restoreBackground();
        if (document.activeElement === document.body || panel.contains(document.activeElement)) trigger.focus({ preventScroll: true });
      }
    }
    function tick(now) {
      frame = 0;
      var dt = Math.max(0, (now - previous) / 1000); previous = now;
      if (drag) { paint(); return; }
      if (motion.reduced.matches) {
        var fraction = Math.min(1, (now - fadeStart) / 120);
        x = fadeFrom + (target - fadeFrom) * fraction;
        if (fraction === 1) { finish(); return; }
      } else {
        var omega = 2 * Math.PI / (mobile() ? .3 : .4), ratio = momentum ? .8 : 1;
        var offset = x - target, a = ratio * omega, decay = Math.exp(-a * dt), v = velocity;
        if (ratio === 1) {
          var b = v + omega * offset;
          x = target + (offset + b * dt) * decay;
          velocity = (v - omega * b * dt) * decay;
        } else {
          var frequency = omega * Math.sqrt(1 - ratio * ratio), sin = Math.sin(frequency * dt), cos = Math.cos(frequency * dt);
          x = target + decay * (offset * cos + (v + a * offset) / frequency * sin);
          velocity = decay * (v * cos - (a * v + omega * omega * offset) / frequency * sin);
        }
        if (Math.abs(x - target) < distance * .0002 && Math.abs(velocity) < distance * .002) { finish(); return; }
      }
      paint(); frame = requestAnimationFrame(tick);
    }
    function cancelCapture() {
      var held = drag; drag = null;
      if (held && panel.hasPointerCapture(held.id)) panel.releasePointerCapture(held.id);
    }
    function settle(next, releaseVelocity) {
      cancelCapture(); stop(); open = next;
      if (next && !shown) {
        suppressClick = false;
        layout(); x = distance; velocity = 0; shown = true;
        panel.inert = false;
        panel.setAttribute('aria-hidden', 'false');
        trigger.setAttribute('aria-expanded', 'true');
        prepareBackground();
      }
      target = next ? 0 : distance;
      momentum = releaseVelocity !== undefined && releaseVelocity !== 0;
      if (releaseVelocity !== undefined) velocity = releaseVelocity;
      if (motion.keyboard) finish();
      else {
        panel.style.willChange = motion.reduced.matches ? 'opacity' : 'transform, opacity';
        fadeStart = previous = performance.now(); fadeFrom = x;
        paint(); frame = requestAnimationFrame(tick);
      }
      if (next) (panel.querySelector('.is-selected') || panel.querySelector('.Popover__Value')).focus({ preventScroll: true });
    }
    function sample(event) {
      drag.samples.push({ x: x, time: event.timeStamp });
      drag.samples = drag.samples.filter(function (s) { return event.timeStamp - s.time <= 80; });
    }
    function move(event) {
      if (!drag || event.pointerId !== drag.id) return;
      var dx = event.clientX - drag.startX, dy = event.clientY - drag.startY;
      if (!drag.active) {
        if (Math.hypot(dx, dy) < 10) return;
        if (Math.abs(dx) > 1.2 * Math.abs(dy)) { release(event, true); return; }
        if (Math.abs(dy) < 1.2 * Math.abs(dx)) return;
        drag.active = true; panel.setPointerCapture(event.pointerId);
      }
      event.preventDefault();
      var value = drag.origin + dy, boundary = Math.max(0, Math.min(distance, value)), excess = value - boundary;
      x = boundary + excess * distance * .55 / (distance + .55 * Math.abs(excess));
      sample(event);
      if (!frame) frame = requestAnimationFrame(function () { frame = 0; paint(); });
    }
    function release(event, cancelled) {
      if (!drag || drag.id !== event.pointerId) return;
      if (drag.active && !cancelled) move(event);
      var held = drag;
      if (!held) return;
      sample(event); cancelCapture();
      if (!held.active) { settle(open); return; }
      suppressClick = true;
      var first = held.samples[0], last = held.samples[held.samples.length - 1];
      var speed = cancelled || last.time === first.time ? 0 : (last.x - first.x) * 1000 / (last.time - first.time);
      var projected = x + speed / 1000 * .998 / (1 - .998);
      settle(cancelled ? open : projected < distance / 2, speed);
    }
    listen(document, 'click', function (event) {
      if (trigger.contains(event.target)) {
        event.preventDefault(); event.stopImmediatePropagation(); settle(!open); return;
      }
      if (!shown) return;
      if (panel.contains(event.target)) {
        if (suppressClick && event.detail !== 0) {
          suppressClick = false; event.preventDefault(); event.stopImmediatePropagation(); return;
        }
        if (event.target.closest('[data-action="close-popover"]')) {
          event.preventDefault(); event.stopImmediatePropagation(); settle(false);
        } else if (event.target.closest('[data-action="select-value"]')) settle(false);
      } else if (event.target === overlay || !mobile()) settle(false);
    }, true);
    listen(document, 'keydown', function (event) {
      if (!shown) return;
      if (event.key === 'Escape') { event.preventDefault(); event.stopImmediatePropagation(); settle(false); }
      if (event.key === 'Tab' && mobile()) {
        var items = Array.from(panel.querySelectorAll('button:not(:disabled)')).filter(function (el) { return el.getClientRects().length && getComputedStyle(el).visibility !== 'hidden'; });
        var index = items.indexOf(document.activeElement);
        if (event.shiftKey && index <= 0 || !event.shiftKey && index === items.length - 1) {
          event.preventDefault(); items[event.shiftKey ? items.length - 1 : 0].focus();
        }
      }
    }, true);
    listen(panel, 'pointerdown', function (event) {
      if (event.isPrimary) suppressClick = false;
      if (!mobile() || !shown || motion.reduced.matches || !event.isPrimary || event.button !== 0 || drag ||
          !event.target.closest('.Popover__Header') || event.target.closest('button, a, input')) return;
      suppressClick = false;
      x = new DOMMatrixReadOnly(getComputedStyle(panel).transform).m42;
      stop();
      drag = { id: event.pointerId, startX: event.clientX, startY: event.clientY, origin: x, active: false, samples: [{ x: x, time: event.timeStamp }] };
      panel.setPointerCapture(event.pointerId);
    });
    listen(panel, 'pointermove', move, { passive: false });
    listen(panel, 'pointerup', function (event) { release(event, false); });
    listen(panel, 'pointercancel', function (event) { release(event, true); });
    listen(panel, 'lostpointercapture', function (event) { if (event.target === panel) release(event, true); });
    listen(panel, 'pointerleave', function (event) { if (drag && !drag.active) release(event, true); });
    function resize() {
      if (!shown) return;
      cancelCapture(); restoreBackground(); layout(); prepareBackground(); target = open ? 0 : distance; finish();
    }
    listen(window, 'resize', resize);
    listen(motion.reduced, 'change', function () { if (shown) { cancelCapture(); finish(); } });
    active = { destroy: function () { stop(); cancelCapture(); if (shown) restoreBackground(); listeners.forEach(function (remove) { remove(); }); } };
  }
  attach();
  document.addEventListener('shopify:section:load', attach);
  document.addEventListener('shopify:section:unload', function (event) {
    if (active && event.target.querySelector('#collection-sort-popover')) { active.destroy(); active = null; }
  });
})();
